import { ColorSpace, contrast, parse, sRGB } from 'colorjs.io/fn';

ColorSpace.register(sRGB);

const getContrast = (backgroundHex: string, foregroundHex: string) => {
  const backgroundColor = parse(backgroundHex);
  const foregroundColor = parse(foregroundHex);

  return contrast(backgroundColor, foregroundColor, 'WCAG21');
};

export default getContrast;
